import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { all_routes } from "../../../Router/all_routes";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

/**
 * j'essaie ici de simululé un composant que va agir comme un session dans nos projet php
 * Composant de garde de session : vérifie la présence d'une variable
 * dans localStorage et redirige si elle est absente ou invalide.
 * 
 *
 * @param {string} storageKey - La clé dans le localStorage : avec ceci il sera possible de gere plusieurs variable de session avec le meme composant
 * @param {string} propsup - un element a checker dans le json
 * @param {string} redirectTo - le composant ou il faut rediriger en cas d'absence
 */

const SessionControl = ({ storageKey = "user", propsup, redirectTo = all_routes.signin }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const MySwal = withReactContent(Swal);
    const raw = localStorage.getItem(storageKey);
    if (!raw) {
      navigate(redirectTo);
      return;
    }

    try {
      const data = JSON.parse(raw);
      if (propsup && !data[propsup]) {
        navigate(redirectTo);
      }
      const token = data.access_token;

      const decoded = jwtDecode(token);

      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        console.log("Le token est expiré.");
        MySwal.fire({
               icon: "success",
               // title: "Session expirée",
               text: "Bien vouloir vous reconectez de nouveau",
               toast: true,
               position: "bottom-end",
               showConfirmButton: false,
               timer: 3000,
               timerProgressBar: true,
               customClass: {
                 popup: "pixel-toast", 
               },
             });
        localStorage.removeItem("user"); 
        navigate(redirectTo);
        return;
      } else{
        console.log("Le token est vivant.");
      }
    } catch (e) {
      console.error("Erreur structure du json problematique", e);
      navigate(redirectTo);
    }
  }, [navigate, storageKey, propsup, redirectTo]);

  return null; // Ce composant ne rend rien
};

SessionControl.propTypes = {
  storageKey: PropTypes.string,
  propsup: PropTypes.string,
  redirectTo: PropTypes.string,
};

export default SessionControl;